import React, { useEffect, useState, useRef } from "react";
import { useSelector, useDispatch } from "react-redux";
import { database, storage } from "../../firebase";
import AsideNewFeed from "../../components/AsideNewFeed";
import AsideContacts from "../../components/AsideContacts";
import json_notify from "./dummydata";
import { DotLoader } from "react-spinners";
import { css } from "@emotion/react";
import { Link } from "react-router-dom";
import NotificationBadge from "react-notification-badge";
import { useCollectionData } from "react-firebase-hooks/firestore";
import { useParams } from "react-router-dom";
import firebase from "firebase/app";
import "firebase/firestore";
import groupBy from "lodash.groupby";
import moment from "moment";
import { Effect } from "react-notification-badge";


const firestore = firebase.firestore();
const AllMessages = () => {
  let { id } = useParams();

  const { currentUser } = useSelector((state) => ({
    currentUser: state.profile.currentUser,
    creditzIds: state.profile.creditzIds,
  }));
  const [loading, setLoading] = useState(false);
  const messageRef4 = firestore
    .collection("usermessages")
    .doc(currentUser.uid)
    .collection("messages");
  const query = messageRef4.orderBy("createdAt");
  const [messages] = useCollectionData(query, { idField: "id" });
  const [usermessages, setUserMessages] = useState([]);
  const [unread, setUnread] = useState([]);

  let [color] = useState();
  const override = css`
    display: block;
    margin: 0 auto;
    border-color: purple;
    color: purple;
    opacity: 0.5;
  `;

  function getUserData(uid) {
    return new Promise((resolve, reject) => {
      return database.ref("users/" + uid).once("value", (snap) => {
        resolve(snap.val());
      });
    });
  }
  async function updateRead(msg) {
    var batch = firestore.batch();
    let unreadArray = [];
    msg.message.forEach(async (message) => {
      if (message.isread === false) {
        if (msg.user_details.uid === message.senderid) {
          let ref = firestore
            .collection("usermessages")
            .doc(currentUser.uid)
            .collection("messages")
            .doc(message.id);
          batch.update(ref, "isread", true);
          message.isread = true;
        } else {
          if (
            unreadArray[message.senderid] &&
            unreadArray[message.senderid].length
          ) {
            unreadArray[message.senderid].push(message);
          } else {
            unreadArray[message.senderid] = [message];
          }
        }
      }
    });
    setUnread((oldValues) => [...unreadArray]);
    batch.commit();
  }
  async function getMessages() {
    setLoading(true)

    var group = groupBy(messages, function (b) {
      return b.senderid;
    });
    const groups = Object.values(group);
    const arrs = groups.map((users) => {
      return users;
    });
    var newRes = await Promise.all(
      arrs.map(async (user, i) => {
        const data = await getUserData(user[0].senderid);
        return { message: user, user_details: data };
      })
    );
    newRes.sort(function (x, y) {
      return (
        y.message[y.message.length - 1].timestamp -
        x.message[x.message.length - 1].timestamp
      );
    });
let readArray=[];  
var batch = firestore.batch();
newRes.forEach((isread) => {
  isread.message.forEach((message) => {
    if (message.isread === false) {
      const key = message.senderid;
      if (
        readArray[key] &&
        readArray[key].length &&
        message.senderid !== id
      ) {
        readArray[key].push(message);
      } else {
        if (message.senderid !== id) {
          readArray[key] = [message];
        }
      }
      if (message.senderid === id) {
        let ref = firestore
          .collection("usermessages")
          .doc(currentUser.uid)
          .collection("messages")
          .doc(message.id);
        batch.update(ref, "isread", true);

        message.isread = true;
      }
    }
  });


})
setUnread(readArray);
batch.commit();
setUserMessages(newRes);
setLoading(false)

  }
  
  
  useEffect(() => {
    getMessages();
  }, [messages]);

   
  return (
    <>
      <AsideNewFeed></AsideNewFeed>

      <section className="main-content">
        <div className="middle-box">
          <div className="row">
            <div className="col-sm-12 mb-5">
              <div className="card border-0 rounded-xl shadow-xs">
                <div className="card-body p-md-4">
                  {loading == true ? (
                    <DotLoader
                      color={color}
                      css={override}
                      size={100}
                      color={"#7444C0"}
                    />
                  ) : (
                    usermessages &&
                    usermessages.map((notif, index) => (
                      <div key={index} onClick={() => updateRead(notif)}>
                      <Link to={`/Messages/${notif.user_details.uid}`}>
                         {unread && unread[notif.user_details?.uid] ? (
                                <NotificationBadge
                                  count={unread[notif.user_details?.uid].length}
                                  effect={Effect.SCALE}
                                />
                              ) : (
                                ""
                              )}
                        <div className="d-flex bg-light-hover p-2 rounded-lg align-items-start mb-2">
                          <div className="mmwh-45 overflow-hidden rounded-pill me-3">
                            <img
                              src={notif.user_details.profileImageUrl}
                              className="w-100"
                              alt="user"
                            />
                          </div>

                          <div className="me-auto w-100-m125 align-self-center">
                            <div className="fs-13 mb-1 capitalize">
                              <strong>
                                {notif.user_details.firstName +
                                  " " +
                                  notif.user_details.lastName}{" "}
                              </strong>
                            </div>
                            <div className="fs-14 fw-semibold text-black-50">

                              {
                              notif.message[notif.message.length-1].user===currentUser.uid? `You: ${notif.message[notif.message.length - 1].text}` :  notif.message[notif.message.length - 1].text } 
                            
                            </div>
                          </div>
                          <div className="ms-auto dropdown">
                            <div className="fs-11 fw-semibold text-black-50">
                              {moment(
                                notif.message[notif.message.length - 1]
                                  .timestamp
                              ).fromNow()}{" "}
                            </div>
                          </div>
                        </div>
                      </Link>
                      </div>
                    ))
                  )}
                </div>
              </div>
              
            </div>
          </div>
          
        </div>
        
      </section>

      {/* Right Aside */}
      <AsideContacts></AsideContacts>
    </>
  );
};

export default AllMessages;
